(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Lock collection promo height to prevent stretching when product cards are hovered
  (() => {
    const lockPromoHeights = () => {
      const promos = document.querySelectorAll('.collection-promo');
      const productGrid = document.querySelector('.product-grid');
      
      if (!promos.length || !productGrid) return;

      // Wait for layout to settle
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          // Store initial heights after layout
          const initialHeights = new Map();
          promos.forEach((promo) => {
            // Get height from computed style to get the stretched height
            const height = window.getComputedStyle(promo).height;
            initialHeights.set(promo, height);
          });

          // Lock height when product cards are hovered
          const productItems = productGrid.querySelectorAll('.product-grid__item');
          productItems.forEach((item) => {
            item.addEventListener('mouseenter', () => {
              promos.forEach((promo) => {
                const initialHeight = initialHeights.get(promo);
                if (initialHeight) {
                  promo.style.setProperty('height', initialHeight, 'important');
                  promo.style.setProperty('max-height', initialHeight, 'important');
                }
              });
            });

            item.addEventListener('mouseleave', () => {
              promos.forEach((promo) => {
                promo.style.removeProperty('height');
                promo.style.removeProperty('max-height');
              });
            });
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', lockPromoHeights);
    } else {
      lockPromoHeights();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
